<template>
    <div class="preview-image-container" v-bind:class="{ engraving_preview_inactive: !engravingPreviewActive }">
        <svg class="engraving_preview_image" role="img" viewBox="0 0 1079 573">
            <image :href="previewImage.original_image_path" height="573" width="1079"></image>
            <text
                v-if="engravingPreviewActive"
                class="preview_text"
                dominant-baseline="middle"
                text-anchor="middle"
                :font-size="fontSize"
                y="280"
                x="540"
                :font-family="engravingFont"
                :fill="engravingFontColor"
            >
                {{ engravingText }}
            </text>
        </svg>
        <span v-if="!engravingPreviewActive" class="engraving_preview_not_available">
            {{ 'Please enter a text or upload a logo to see the preview.' | translation }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ImagePreview',
    props: {
        engravingPreviewActive: {
            type: Boolean,
            default: false,
        },
        engravingText: String,
        engravingFont: String,
        engravingFontColor: String,
        previewImage: Object,
        fontSize: Number,
    },
};
</script>

<style scoped lang="stylus">
@import '~vuetify/src/stylus/settings/_variables.styl';
@import url('https://fonts.googleapis.com/css2?family=Allura&family=Carter+One&family=Kalam&family=Reem+Kufi&family=Scheherazade+New&display=swap');

.preview-image-container {
  position: relative;
  text-align: center;
}

.engraving_preview_image {
  box-shadow: 0 0 5px #c1c1c1;
}

.engraving_preview_inactive >>> .engraving_preview_image {
    filter: grayscale(100%);
    opacity: 0.59;
}

.engraving_preview_not_available {
    font-size: 14px;
    color: #000;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media(min-width: $grid-breakpoints.sm) {
      font-size: 18px;
    }
    @media(min-width: $grid-breakpoints.md) {
        font-size: 24px;
    }
}
</style>
